import "./index.scss";

import { Provider as RollbarProvider } from "@rollbar/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import TagManager from "react-gtm-module";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router } from "react-router-dom";
import { rollbarConfig } from "utils/rollbarConfig";

import { AppWrapper } from "./AppWrapper";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime 59 mins
      // (JWTs last for one hour so expire a query before the current JWT or refresh token)
      staleTime: 1000 * 60 * 59,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = createRoot(document.getElementById("root"));

const RootApp = () => {
  useEffect(() => {
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GOOGLE_TAGMANAGER_ID || "",
    });
  }, []);

  return (
    <React.StrictMode>
      <Router>
        <RollbarProvider config={rollbarConfig}>
          <QueryClientProvider client={queryClient}>
            <HelmetProvider>
              <Helmet>
                <link
                  rel="icon"
                  href={`${process.env.REACT_APP_PUBLIC_URL}/favicon.ico`}
                />
                <link
                  rel="manifest"
                  href={`${process.env.REACT_APP_PUBLIC_URL}/manifest.json`}
                />
              </Helmet>
              <main>
                <AppWrapper />
              </main>
            </HelmetProvider>
          </QueryClientProvider>
        </RollbarProvider>
      </Router>
    </React.StrictMode>
  );
};

root.render(<RootApp />);
